function bindQuickViewButtons() {
  function initProductSliders() {
    const thumbSlider = new Swiper(".qv_nav_slider", {
      freeMode: false,
      watchSlidesProgress: true,
      breakpoints: {
        300: {
          slidesPerView: 4.2,
          spaceBetween: 6,
        },
        767: {
          slidesPerView: 5,
          spaceBetween: 6,
        },
      },
    });

    const mainSlider = new Swiper(".qv_main_slider", {
      spaceBetween: 2,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".qv_main_slider .swiper-button-next",
        prevEl: ".qv_main_slider .swiper-button-prev",
      },
      thumbs: {
        swiper: thumbSlider,
      },
    });
  }
  function setVariantChange() {
    const packSizeRadios = document.querySelectorAll(
      'fieldset.quick-form__input input[type="radio"]'
    );
    const purchaseOptionRadios = document.querySelectorAll(
      '.custom_recharge_widget input[name="purchase_option"]'
    );

    const oneTimePriceEl = document.querySelector(".one-time-price");
    const mainPriceEl = document.querySelector(
      ".subscribe_save_purchase .save_price .main_price"
    );
    const discountedPriceEl = document.querySelector(
      ".subscribe_save_purchase .save_price .discounted_price"
    );

    const addToCartButtons = document.querySelectorAll(
      ".product-form__submit .rc-add-to-cart, .product-form__buttons .product-form__submit .rc-add-to-cart"
    );

    const addToCartWrappers = document.querySelectorAll(
      ".product-form__submit, .product-form__buttons .product-form__submit"
    );

    function formatPrice(num) {
      return `$${num.toFixed(2)}`;
    }

    function updatePrices(basePrice) {
      const discounted = basePrice * 0.9;
      const mainPrice = formatPrice(basePrice);
      const discountedPrice = formatPrice(discounted);
      if (oneTimePriceEl) oneTimePriceEl.textContent = mainPrice;
      if (mainPriceEl) mainPriceEl.textContent = mainPrice;
      if (discountedPriceEl) discountedPriceEl.textContent = discountedPrice;

      const selectedOption = document.querySelector(
        '.custom_recharge_widget input[name="purchase_option"]:checked'
      )?.value;

      if (selectedOption === "onetime") {
        addToCartButtons.forEach((btn) => {
          btn.innerHTML = `<span class="rc_main_price">${mainPrice}</span>`;
        });
      }

      if (selectedOption === "subscription") {
        addToCartButtons.forEach((btn) => {
          btn.innerHTML = `<span class="rc_discounted_price">${discountedPrice}</span>
                       <span class="rc_onetime_price">${mainPrice}</span>`;
        });
      }
    }

    packSizeRadios.forEach((radio) => {
      radio.addEventListener("change", function () {
        const label = document.querySelector(`label[for="${this.id}"]`);
        const priceAttr = label.getAttribute("variantprice");

        document
          .querySelectorAll(".item_price_label")
          .forEach((el) => el.classList.remove("active"));
        const itemPriceLabel = this.nextElementSibling;
        if (
          itemPriceLabel &&
          itemPriceLabel.classList.contains("item_price_label")
        ) {
          itemPriceLabel.classList.add("active");
          const perItemPriceEl = itemPriceLabel.querySelector("label");
          if (perItemPriceEl) {
            const getID = perItemPriceEl.getAttribute("variantid");
            const idInput = document.querySelector(
              '.quick_view_form form input[name="id"]'
            );
            if (idInput && getID) {
              idInput.value = getID;
            }
          }
        }
        if (priceAttr) {
          const basePrice = parseFloat(priceAttr.replace("$", ""));
          updatePrices(basePrice);
        }
      });
    });

    purchaseOptionRadios.forEach((radio) => {
      radio.addEventListener("change", function () {
        const form = document.querySelector(".quick_view_form form");
        if (!form) return;

        let hiddenInput = form.querySelector('input[name="selling_plan"]');
        if (!hiddenInput) {
          hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = "selling_plan";
          form.insertBefore(
            hiddenInput,
            form.querySelector('input[type="hidden"]')
          );
        }

        if (this.closest(".subscribe_save_purchase")) {
          const dropdown = this.closest(
            ".subscribe_save_purchase"
          ).querySelector(".selling_plan_dropdown");
          if (dropdown) {
            hiddenInput.value = dropdown.value;
            dropdown.addEventListener("change", function () {
              hiddenInput.value = this.value;
            });
          }
        } else {
          hiddenInput.value = "";
        }

        const activePack = document.querySelector(
          'fieldset.quick-form__input input[type="radio"]:checked'
        );
        if (activePack) {
          const label = document.querySelector(`label[for="${activePack.id}"]`);
          const priceAttr = label.getAttribute("variantprice");
          if (priceAttr) {
            const basePrice = parseFloat(priceAttr.replace("$", ""));
            updatePrices(basePrice);
          }
        }
      });
    });

    const initialPack = document.querySelector(
      'fieldset.quick-form__input input[type="radio"]:checked'
    );
    if (initialPack) {
      const label = document.querySelector(`label[for="${initialPack.id}"]`);
      const priceAttr = label.getAttribute("variantprice");
      if (priceAttr) {
        const basePrice = parseFloat(priceAttr.replace("$", ""));
        updatePrices(basePrice);
      }
    }
  }
  const modal = document.getElementById("azo_quick_view_modal");
  const modalBody = modal.querySelector(".quick_view_body");
  const closeBtn = modal.querySelector(".quick_view_close");
  const popupHeader = modal.querySelector(".quick_view_header");
  let startY = 0;
  popupHeader.addEventListener("touchstart", (e) => {
    startY = e.touches[0].clientY;
  });
  popupHeader.addEventListener("touchend", (e) => {
    const endY = e.changedTouches[0].clientY;
    const diffY = startY - endY;
    if (diffY > 30) {
      modal.classList.add("popup_fullscreen");
    } else if (diffY < -30) {
      modal.classList.remove("popup_fullscreen");
    }
  });
  popupHeader.addEventListener("mouseover", () => {
    popupHeader.classList.add("hovered");
  });

  document.querySelectorAll(".azo_quick_view_btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const handle = this.getAttribute("data-product-handle");
      document.body.style.overflow = "hidden";
      modal.style.display = "flex";
      closeBtn.style.display = "none";
      modalBody.innerHTML = `
      <div class="load_product_data">
      <div class="col_left skeleton">
      </div>
      <div class="col_right">
      <ul>
        <li class="skeleton"></li>
        <li class="skeleton"></li>
        <li class="skeleton"></li>
      </ul>
      <div class="small skeleton"></div>
      <div class="medium skeleton"></div>
      <div class="box ">
      <span class="skeleton"></span>
      <span class="skeleton"></span>
      </div>
      <div class="medium skeleton"></div>
      <div class="large skeleton"></div>
      </div>
      </div>
      `;
      fetch(`/products/${handle}?view=quick-view`)
        .then((res) => res.text())
        .then((html) => {
          modalBody.innerHTML = html;
          closeBtn.style.display = "grid";
          initProductSliders();
          setVariantChange();
        })
        .catch(() => {
          modalBody.innerHTML = "Failed to load product details.";
        });
    });
  });
  function closeQuickView() {
    modal.style.display = "none";
    document.body.style.overflow = "";
  }
  closeBtn.addEventListener("click", closeQuickView);
  window.addEventListener("click", (e) => {
    if (e.target === modal) closeQuickView();
  });
}
document.addEventListener("DOMContentLoaded", function () {
  bindQuickViewButtons();
});
